import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import coreService from "@/utils/axios/core-service";
import { API_ENDPOINTS, RESPONSE_STATUSES } from "@/constants/api-endpoints";
import { MARKET_PLACES } from "@/constants/app";

export const fetchMiraklItemConditionData = createAsyncThunk(
  "miraklItemConditions/fetchAll",
  async ({ page = 0, size = 5 } = {}, thunkAPI) => {
    try {
      const response = await coreService.post(
        `${API_ENDPOINTS.ADMIN.SETTINGS.EBAY.ITEM_CONDITION.GET_ALL}?page=${page}&size=${size}&sort=id,asc`,
        [
          {
            fieldName: "marketPlace",
            fieldValue: MARKET_PLACES.MIRAKL,
            searchOperator: "LIKE",
          },
        ],
      );

      if (response.data?.status == RESPONSE_STATUSES.SUCCESS) {
        return response.data.data.content || [];
      }

      return thunkAPI.rejectWithValue("Unexpected response from server");
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message || "API error");
    }
  },
);

export const submitMiraklItemCondition = createAsyncThunk(
  "miraklItemConditions/submit",
  async ({ payload, page, size, t }, thunkAPI) => {
    try {
      const response = await coreService.post(
        API_ENDPOINTS.ADMIN.SETTINGS.EBAY.ITEM_CONDITION.CREATE,
        payload,
      );

      if (response.data.status == RESPONSE_STATUSES.CREATED) {
        await thunkAPI
          .dispatch(fetchMiraklItemConditionData({ page, size }))
          .unwrap();

        return t("itemConditionUpdatedSuccessfully");
      } else {
        return thunkAPI.rejectWithValue(t("failedToUpdatedItemCondition"));
      }
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err?.message || "Unexpected server error",
      );
    }
  },
);

const miraklItemConditionSlice = createSlice({
  name: "miraklItemCondition",
  initialState: {
    miraklItemConditionData: [],
    miraklItemConditionLoading: false,
    miraklItemConditionError: null,
    submitLoading: false,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(fetchMiraklItemConditionData.pending, (state) => {
        state.miraklItemConditionLoading = true;
        state.miraklItemConditionError = null;
      })
      .addCase(fetchMiraklItemConditionData.fulfilled, (state, action) => {
        state.miraklItemConditionLoading = false;
        state.miraklItemConditionData = action.payload;
      })
      .addCase(fetchMiraklItemConditionData.rejected, (state, action) => {
        state.miraklItemConditionLoading = false;
        state.miraklItemConditionError = action.payload;
        state.miraklItemConditionData = [];
      })
      .addCase(submitMiraklItemCondition.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(submitMiraklItemCondition.fulfilled, (state) => {
        state.submitLoading = false;
      })
      .addCase(submitMiraklItemCondition.rejected, (state) => {
        state.submitLoading = false;
      });
  },
});

export default miraklItemConditionSlice.reducer;
